<template>
    <div class="placeholder" v-bind:style="{ 'min-height': `${outrightMatchPlaceHolderHeight}px` }">
        <div>
            {{ league.name }}
        </div>
        <div
            v-for="(oddsItem, index) in leftColumnOdds"
            v-if="!isCollapsed"
            v-bind:key="oddsItem.id"
        >
            {{ getTranslated(oddsItem.teamName) }}
            <template v-if="rightColumnOdds[index]">
                <div>
                    {{ getTranslated(rightColumnOdds[index].teamName) }}
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import orderBy from 'lodash/orderBy';
    import type { PropType, Ref } from 'vue';
    import { computed, toRefs } from 'vue';
    import { getOutrightMatchPlaceHolderHeight } from '@/components/oddsDisplay/oddsTableCalculation';
    import { OutrightOddsDisplayContext } from '@/components/oddsDisplay/outright/OutrightOddsDisplayContext';
    import { getTranslated } from '@/core/lib/translationHelper';
    import { useOutrightOdds } from '@/core/oddsApi/composable/useOutrightOdds';
    import type { IOutrightLeague } from '@/interface/IOutrightLeague';
    import type { IOutrightOdds } from '@/interface/IOutrightOdds';

    const props = defineProps({
        league: {
            type: Object as PropType<IOutrightLeague>,
            required: true,
        },
        isLive: {
            type: Boolean,
            required: true,
        },
    });

    const { league, isLive } = toRefs(props);

    const { sportType, isItemCollapsedRef } = OutrightOddsDisplayContext.inject();
    const { outrightOdds }: { outrightOdds: Ref<(IOutrightOdds)[]> } = useOutrightOdds(sportType.value, league.value.id, isLive.value);

    const sortedOutrightOdds = computed(() => orderBy(outrightOdds.value, [x => x.price, x => getTranslated(x.teamName)]));
    const leftColumnOdds = computed(() => sortedOutrightOdds.value.slice(0, Math.ceil(sortedOutrightOdds.value.length / 2)));
    const rightColumnOdds = computed(() => sortedOutrightOdds.value.slice(Math.ceil(sortedOutrightOdds.value.length / 2)));

    const outrightMatchPlaceHolderHeight = computed(() => getOutrightMatchPlaceHolderHeight(league.value));

    const isCollapsed = isItemCollapsedRef(league.value.id);
</script>

<style lang="scss" scoped>
.placeholder {
    opacity: 0;
}
</style>
